// @flow
import React from 'react';

import Notification from './Notification';
import Diagnostics from "./Diagnostics";

class DiagnosticsPage extends React.Component {
	render() {
		return (
			<div id="config_content">
				<Notification />
				<Diagnostics />
			</div>
		);
	}
}

export default DiagnosticsPage;
